/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PresentingConcernSectionResponseDto } from './PresentingConcernSectionResponseDto';
import {
    PresentingConcernSectionResponseDtoFromJSON,
    PresentingConcernSectionResponseDtoFromJSONTyped,
    PresentingConcernSectionResponseDtoToJSON,
    PresentingConcernSectionResponseDtoToJSONTyped,
} from './PresentingConcernSectionResponseDto';

/**
 * 
 * @export
 * @interface PresentingConcernsResponseDto
 */
export interface PresentingConcernsResponseDto {
    /**
     * Patient identity
     * @type {string}
     * @memberof PresentingConcernsResponseDto
     */
    patientId: string;
    /**
     * Array of 3 presenting concern sections
     * @type {Array<PresentingConcernSectionResponseDto>}
     * @memberof PresentingConcernsResponseDto
     */
    presentingConcerns: Array<PresentingConcernSectionResponseDto>;
}

/**
 * Check if a given object implements the PresentingConcernsResponseDto interface.
 */
export function instanceOfPresentingConcernsResponseDto(value: object): value is PresentingConcernsResponseDto {
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('presentingConcerns' in value) || value['presentingConcerns'] === undefined) return false;
    return true;
}

export function PresentingConcernsResponseDtoFromJSON(json: any): PresentingConcernsResponseDto {
    return PresentingConcernsResponseDtoFromJSONTyped(json, false);
}

export function PresentingConcernsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PresentingConcernsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'patientId': json['patientId'],
        'presentingConcerns': ((json['presentingConcerns'] as Array<any>).map(PresentingConcernSectionResponseDtoFromJSON)),
    };
}

export function PresentingConcernsResponseDtoToJSON(json: any): PresentingConcernsResponseDto {
    return PresentingConcernsResponseDtoToJSONTyped(json, false);
}

export function PresentingConcernsResponseDtoToJSONTyped(value?: PresentingConcernsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patientId': value['patientId'],
        'presentingConcerns': ((value['presentingConcerns'] as Array<any>).map(PresentingConcernSectionResponseDtoToJSON)),
    };
}

